var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "main-app" } },
    [
      _c("TopBar"),
      _vm._v(" "),
      _c("Header"),
      _vm._v(" "),
      _vm.navigation && _vm.navigation.length > 0
        ? _c("b-breadcrumb", { attrs: { items: _vm.navigation } })
        : _vm._e(),
      _vm._v(" "),
      _c("AlertContainer"),
      _vm._v(" "),
      _c(
        "main",
        [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "loader",
            attrs: { src: require("@/assets/loader.svg") }
          }),
          _vm._v(" "),
          _c("router-view")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04c2046b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04c2046b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = QooG
// module chunks = 15